import { Button, notification, PageHeader, Typography, Spin } from 'antd';
import BottomButton from '../../../Buttons/BottomButton';
import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { generateJobseekerOtp, getUserDetailsById, verifyJobseekerOtp } from '../../../../services/API/MarketplaceService';
import { Routes } from '../../../../constants/RouterConstants';
import {Navigation} from '../../../../services/NavigationService';
import '../../../../styles/components/MarketPlace/CityWiseJobs.scss';
import { useTranslation } from 'react-i18next';
import DuplicateApplicationPopup from '../../popups/DuplicateApplicationPopup';

const TIMER = 60;
const OTP_STATUS = {start: 'START_TIMER', stop: 'STOP_TIMER'};

function useQuery() {
    const { search } = useLocation();
  
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

const {Text} = Typography;

function OTPScreen() {
    let query = useQuery();
    const siId = query.get("siId");
    // const [showResendOTP, setShowReSendOTP] = useState(false);
    const [currentTimer, setCurrentTimer] = useState(TIMER);
    const [currentOTPStatusCounter, setCurrentOtpStatusCounter] = useState('');
    const [otp, setOtp] = useState('');
    let timerInterval;
    let timer = TIMER;
    const history = useHistory();
    const [userDetails, setUserDetails] = useState({});
    const [showSendOTP, setShowSendOTP] = useState(true);
    const [loading, setLoading] = useState(false);
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [isOtpSent, setIsOtpSent] = useState(false);
    const {t, i18n} = useTranslation();
    const [showDuplicateApplicationPopup, setShowDuplicateApplicationPopup] = useState(false);

    const BUTTON_STYLE = {
        background: '#D34B18',
        borderRadius: '8px',
        fontFamily: "Open Sans",
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '1.1em',
        lineHeight: '20px',
        textAlign: 'center',
        color: '#FFFFFF',
        width: '100%',
        height: '55px',
        marginTop: '24px',
        opacity: (loading || spinnerLoading) ? '50%':'100%'
    };

    useEffect(() => {
      getUserDetailsById(localStorage.getItem('userId'))
      .then(response => {
        setUserDetails(response.data);
      })
      .catch(err => {
        console.log(err);
      })

    //   sendOTP();
    }, [])
    

    const sendOTP = () => {
        // function to trigger a OTP
        setShowSendOTP(false);
        startResendOtpCounter();
        setCurrentOtpStatusCounter(OTP_STATUS.start);
        triggerOtp();
    };

    const onValueChange = (event) => {
        setOtp(event.target.value);
    };

    const submitOtp = () => {
        setLoading(true);
        // function to submit OTP and redirect to job application status page
        if (!otp) {
            notification['error']({
                message: t('empty_otp_submit')
              });
              setLoading(false);
              return;
        }
        let parsedOtp = otp.toString();
        verifyJobseekerOtp(siId, parsedOtp)
        .then(response => {
            setLoading(false);
            if (response.data.status === 'fail' || response.data?.status?.code !== 200) {
                notification['error']({
                    message: t('incorrect_otp')
                  });
                return;
            } else {
                history.replace(`${Routes.APPLICATION_STATUS}?applicationId=${siId}&city=${localStorage.getItem("preferredLocation")}`);
            }
            
            
        })
        .catch(err => {
            setLoading(false);
            notification['error']({
                message: 'Issue submitting the OTP, please contact support !'
              });
        })

    };

    const startResendOtpCounter = () => {
        timerInterval = setInterval(() => {
            timer = timer -1;
            setCurrentTimer(timer);
            if (timer === 0) {
                clearInterval(timerInterval);
                setCurrentOtpStatusCounter(OTP_STATUS.stop);
                timer = TIMER;
                setCurrentTimer(TIMER);
            }
        }, 1000);
        
    };

    const triggerOtp = () => {
        setSpinnerLoading(true);
        generateJobseekerOtp(siId)
        .then(response => {
            setSpinnerLoading(false);
            if (response?.status === 200) {
                return response?.data;
            } else throw response?.data?.error;
        })
        .then((responseObj) => {
            if (responseObj?.statusCode === '422') {
                setIsOtpSent(false);
                // notification.error({
                //     message: 'Your number is already registered with Rapido'
                // });
                setShowDuplicateApplicationPopup(true);
            } else if (responseObj?.statusCode === '500') {
                setIsOtpSent(false);
                // notification.info({
                //     message: 'Issue sending OTP, please contact support !'
                //   });
                setShowDuplicateApplicationPopup(true);
            } else {
                if (isOtpSent) {
                    notification.success({
                        message: t('otp_sent_to_device')
                      });
                } else {
                    notification.success({
                        message: t('otp_sent_to_device')
                      });
                }

                setIsOtpSent(true);
            }
        })
        .catch(error => {
            setIsOtpSent(false);
            setSpinnerLoading(false);
            notification['error']({
                message: t('issue_sending_otp')
              });
        })
    };

  return (
    <div>
        <DuplicateApplicationPopup
        open={showDuplicateApplicationPopup} 
        close={() => setShowDuplicateApplicationPopup(false)} 
        accessOrigin={'OTPScreen'}
        jobType='unavailable'
        company=""
        />
        <Spin spinning={spinnerLoading} className="spinner" tip="Loading" />
        <PageHeader 
        onBack={()=> {
            history.replace(`${Routes.APPLICATION_STATUS}?applicationId=${siId}&city=${localStorage.getItem("preferredLocation")}`)
        } }
        className="site-page-header" title="Validate OTP" />

        <div className='otp-container' style={{display:'flex',margin:'24px',flexDirection:'column',gap:'1em'}}>

            <label 
            style={{fontSize:'1.2em', fontWeight:'700'}}
            >
                Enter OTP <br />
                {
                    isOtpSent && !spinnerLoading && (
                        <Text 
                        type="secondary" 
                        style={{fontWeight:700,fontSize:'0.8em'}}
                        >
                            ({t('otp_sent_indicator_1')} +91-{userDetails.userPhoneNumber} {t('otp_sent_indicator_2')})
                        </Text>
                    )
                }
                    
            </label>

            <div className='input-container' style={{position:'relative'}}>
                <input 
                style={{border:'1px solid #d9d9d9', height:'40px', padding:'8px', fontSize:'1em', width:'100%'}} 
                type='number' 
                onChange={onValueChange}
                pattern="[0-9]*" inputMode="numeric"
                placeholder='Enter OTP' />
                
                {
                    showSendOTP ? (
                        <Button 
                        style={BUTTON_STYLE}
                        onClick={sendOTP}
                        disabled={loading || spinnerLoading}
                        >Send OTP to +91-{userDetails.userPhoneNumber}</Button>
                    ) : (
                        <Button 
                        style={BUTTON_STYLE}
                        loading={loading}
                        disabled={loading || spinnerLoading}
                        onClick={submitOtp}
                        >Submit</Button>
                    )
                }
                

                {/* { //COMMENTED: Sending OTP on page reload instead of manual trigger
                    showSendOTP ? (
                        <a 
                        style={{position:'absolute',top:'10px',right:'5%',textDecoration:'underline',color:'#D34B18', fontWeight:'700'}}
                        onClick={sendOTP}
                        >
                            Send OTP
                        </a>
                    ) : null
                } */}
            </div>

            {
                currentOTPStatusCounter === OTP_STATUS.stop ? (
                    <>
                        <a 
                        style={{textDecoration:'underline',color:'#D34B18', fontWeight:'700'}}
                        onClick={sendOTP}
                        >
                            Re-send OTP
                        </a>
                    </>
                ) : currentOTPStatusCounter === OTP_STATUS.start ? <p style={{fontWeight:"700", color:"#D34B18"}}>{t('resend_otp_indicator_1')} {currentTimer} {t('resend_otp_indicator_2')}</p> : null
            }

        </div>
        {/* <BottomButton 
        buttonText="Submit"
        callBackFunction={submitOtp}
        loading={loading}
        disabled={loading}
        /> */}
    </div>
  )
}

export default OTPScreen
